import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage, usePopup } from "@/comn/hooks";
import { BASE, URLS, APIS, SF_GWAY_MGMT_INFO } from "@/tra/tancis/ptli/elctdoc/gway/services/PtliGwayMgmtService";

/*
 * Update Gateway
 * !== 게이트웨이 수정 ==!
 */
export const PTLI0706003S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0047"],
    });
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { gwayId } = useParams();

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0024" }, // 업무 분류 코드
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        gwayForm: useForm({
            defaultSchema: SF_GWAY_MGMT_INFO,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Gateway Information !== 게이트웨이 정보 조회 ==!
        getElctDocGway: useFetch({
            api: () => APIS.getElctDocGway(gwayId),
            enabled: !!gwayId,
            onSuccess: (data) => {
                form.gwayForm.setValues(data.elctDocGway.content);
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    const { errorMessage } = error.response.data;

                    modal.openModal({
                        content: errorMessage.content,
                        onConfirm: () => {},
                        close: false,
                    });

                    return;
                }

                toast.showToast({ type: "error", content: "msg.com.00018" }); // An error occurred. !== 에러가 발생했습니다! ==!
            },
        }),
        // Update Gateway !== 게이트웨이 수정 ==!
        updateElctDocGway: useFetch({
            api: (data) => APIS.updateElctDocGway({ ...data }),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.com.00062", // Successfully saved., !== 정상적으로 저장되었습니다. ==!
                    onConfirm: () => {},
                    close: false,
                });
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    form.gwayForm.setErrors(error.response.data.errors);
                }

                modal.openModal({
                    content: "msg.00006", // An error occurred during processing.
                });
            },
        }),
        // delete Gateway !== 게이트웨이 삭제 ==!
        deleteElctDocGway: useFetch({
            api: () => APIS.deleteElctDocGway(gwayId),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.com.00060", // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                    onCancel: () => {
                        navigate(URLS.ptli0706001q);
                    },
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // on Save Button Click Event Handler  !== 문서함 수정 ==!
        onSaveBtnClick: () => {
            if (!comnUtils.isEmpty(form.gwayForm.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.gwayForm.handleSubmit(
                () => {
                    const data = form.gwayForm.getValues();

                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.updateElctDocGway.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
        // Delete Document box !== 문서함 삭제 ==!
        onDeleteBtnClick: () => {
            modal.openModal({
                content: "msg.com.00049", // Confirm remove? !== 삭제하시겠습니까? ==!
                onConfirm: () => {
                    fetch.deleteElctDocGway.fetch();
                },
            });
        },
    };

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={"T_GWAY_INFO"} titleSize={2}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.gwayForm.schema.gwayId} readOnly={true} controlSize={10} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.gwayForm.schema.gwayUrlAddr} controlSize={10} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.gwayForm.schema.gwayApiKey} controlSize={10} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.gwayForm.schema.clntId} controlSize={10} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.gwayForm.schema.clntSecrtKeyValue} controlSize={10} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.gwayForm.schema.frstRegstId} />
                            <Group.Control {...form.gwayForm.schema.frstRgsrDtm} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>

            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.ptli0706001q);
                        }}
                    />
                </Layout.Left>
                <Layout.Right>
                    <Button
                        role="save"
                        onClick={() => {
                            handler.onSaveBtnClick();
                        }}
                    ></Button>
                    <Layout.Button
                        role={"delete"}
                        onClick={() => {
                            handler.onDeleteBtnClick();
                        }}
                    />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
